<app-selected-project [isEF]="true" [featureAcronym]="featureAcronym"></app-selected-project>
<div *ngIf="!isProjectOwnershipValid && selectedProject" class="isProjectOwnershipValid">
    <p>You can not modify or run someone's project</p>
</div>
<div *ngIf="selectedProject" class="pt-3 pr-5 pb-5 pl-5">
    <app-wizard class="surface-200" [items]="EFLogicService.items" [message]="message" [loading]="loading"
        [activeItem]="activeItem" [selectedProject]="selectedProject" [selectedProjectStatus]="selectedProjectStatus"
        [isSetupValid]="isSetupValid" (activeIndexChangeEmitter)="onActiveIndexChange($event)"></app-wizard>
    <div class="shadow-8 surface-0 p-3">
        <ng-container *ngIf="activeItem?.index == 0">
            <app-ef-setup [menuService]="EFLogicService" [modelsCollection]="modelsCollection"
                [disciplinePk]="disciplinePk" [columnDef]="columnDef" [activeItem]="activeItem"
                [environmentalAssessment]="environmentalAssessment"
                (isSetupValidEvent)="validateSetup($event)"></app-ef-setup>
        </ng-container>
    </div>
</div>
